import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { isNotNullOrUndefined } from '@utils/utils';

interface ComponentProps {
  originalName: string;
}

// Shows the carrier's canonical (original) company name next to the address, alongside the
// per-company custom name shown as the title (RD-2481).
const OriginalNameBadge: React.FC<ComponentProps> = ({ originalName }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      {isNotNullOrUndefined(originalName) && (
        <Badge filled={false} value={originalName} highlightedValue={false} label={tr(`OriginalNameBadge.label`, `Original name`)}></Badge>
      )}
    </>
  );
};

export default OriginalNameBadge;
